export enum ReportOutput {
    Pdf = 1,
    Excel,
    Word,
    CSV,
}